module.exports = __webpack_public_path__ + "static/design-system-logo-485c5546c92233a005ddaff9339e8ecb.png";